import { render, staticRenderFns } from "./BoardType.vue?vue&type=template&id=e1887224&scoped=true"
import script from "./BoardType.vue?vue&type=script&lang=js"
export * from "./BoardType.vue?vue&type=script&lang=js"
import style0 from "./BoardType.vue?vue&type=style&index=0&id=e1887224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1887224",
  null
  
)

export default component.exports